import { GROUPS, PREFIX } from '@/service/apiConf';
import { get } from '@/service/request';

import type { RunPolicyTypesResponse } from './types';

/** 拉取运行策略可选项（computing/all-types.runStrategy） */
export function getRunPolicyTypes(): Promise<RunPolicyTypesResponse> {
  return get(`${PREFIX.vapis_v1_dc_ws(GROUPS.computing)}/all-types`, {}, { flag: true });
}
